/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreManagementListEditItemResponse } from './StoreManagementListEditItemResponse';

export type StoreManagementListEditItemResponseApiRespoonse = {
    data?: StoreManagementListEditItemResponse;
    status?: StoreManagementListEditItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreManagementListEditItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

